<template>
  <base-legal-page
    kicker="Total Chaos"
    title="Total Chaos Privacy Policy"
    updated="March 2026"
  >
    <h2>1. Introduction</h2>
    <p>
      Welcome to Total Chaos ("we," "our," or "us"), developed by Hacker Hang. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use the Total Chaos mobile application. By using Total Chaos, you agree to the collection and use of information in accordance with this policy.
    </p>

    <h2>2. Information We Collect</h2>
    <p>We may collect the following types of information:</p>
    <ul>
      <li><strong>Display Name:</strong> The name you enter when creating or joining a game</li>
      <li><strong>Game Data:</strong> Your answers, scores, and gameplay activity during sessions</li>
      <li><strong>Device Information:</strong> Device type, operating system version, and unique device identifiers</li>
      <li><strong>Usage Data:</strong> How you interact with the app, including game modes played and session duration</li>
    </ul>

    <h2>3. How We Use Your Information</h2>
    <p>We use the information we collect to:</p>
    <ul>
      <li>Provide and operate the Total Chaos game experience</li>
      <li>Enable multiplayer functionality and game sessions</li>
      <li>Improve and optimize app performance</li>
      <li>Fix bugs and troubleshoot technical issues</li>
      <li>Analyze usage trends to enhance our game modes</li>
    </ul>

    <h2>4. Data Sharing</h2>
    <p>
      We do not sell, trade, or rent your personal information to third parties. Game data such as your display name and answers are shared with other players within the same game session as part of normal gameplay. We may share anonymized, aggregated data with analytics providers to help us improve the app.
    </p>

    <h2>5. Data Storage and Security</h2>
    <p>
      Game session data is temporary and is not permanently stored after a session ends. We implement appropriate technical and organizational measures to protect any information we do collect. However, no method of electronic transmission or storage is completely secure, and we cannot guarantee absolute security.
    </p>

    <h2>6. Children's Privacy</h2>
    <p>
      Total Chaos is not directed at children under the age of 13. We do not knowingly collect personal information from children under 13. If you believe we have collected information from a child under 13, please contact us immediately so we can take steps to delete that information.
    </p>

    <h2>7. Third-Party Services</h2>
    <p>
      The app may contain links to or integrations with third-party services. We are not responsible for the privacy practices of these third parties. We encourage you to review the privacy policies of any third-party services you interact with.
    </p>

    <h2>8. Your Rights</h2>
    <p>You have the right to:</p>
    <ul>
      <li>Request access to your personal data</li>
      <li>Request correction or deletion of your data</li>
      <li>Opt out of analytics data collection</li>
      <li>Request a copy of your data</li>
    </ul>
    <p>
      To exercise any of these rights, please contact us using the information below or visit our
      <router-link to="/data-deletion">
        Data Deletion
      </router-link>
      page.
    </p>

    <h2>9. Changes to This Privacy Policy</h2>
    <p>
      We may update this Privacy Policy from time to time. We will notify you of any changes by updating the "Last updated" date at the top of this page. You are advised to review this Privacy Policy periodically for any changes.
    </p>

    <h2>10. Contact Us</h2>
    <p>If you have questions or concerns about this Privacy Policy, please contact us at:</p>
    <div class="hh-legal__contact">
      <div><strong>Email:</strong> <a href="mailto:info@hackerhang.com">info@hackerhang.com</a></div>
      <div><strong>Website:</strong> <a href="https://hackerhang.com">hackerhang.com</a></div>
    </div>
  </base-legal-page>
</template>

<script>
  export default {
    name: 'TotalChaosPrivacy',

    metaInfo: { title: 'Total Chaos Privacy Policy' },
  }
</script>
